import React from 'react';
import LoaderGif from '../../assets/images/loading-transbg.gif';

function Loader(props) {
	const { label } = props;
	return (
		<div className="loader-wrapper" sr-only={label}>
			<img src={LoaderGif} className="loader-icon" role="alert" aria-live="assertive" alt={label} />
		</div>
	);
}

export default Loader;
